/** Long SEO paths for info services — use for Link targets and post sub-routes */
export const PATH_JOBS =
  '/jobs-driver-freight-logistics-recruitment-platform-物流司机招聘求职平台-货运卡车运输人才匹配系统';
export const PATH_LOGISTICS_RENTAL =
  '/logistics-truck-rental-fleet-platform-美国货运物流租车系统-卡车货车设备租赁服务信息平台';
export const PATH_LOGISTICS_RENTAL_ONLY =
  '/logistics-truck-rental-equipment-leasing-物流设备出租平台-卡车叉车仓库租赁服务';
export const PATH_LOGISTICS_SALE_ONLY =
  '/logistics-truck-sale-equipment-trading-物流设备出售平台-卡车叉车仓库买卖交易';
export const PATH_FORUM_LONG =
  '/forum-logistics-driver-community-freight-talk-物流卡车司机论坛交流平台-经验分享与行业资讯讨论区';
export const PATH_YELLOW_PAGES =
  '/yellow-pages-logistics-supplier-directory-物流企业服务商黄页-货运卡车租赁公司查询平台';
